import React, { Component } from "react";
import MetaDecorator from "../../services/MetaDecorator";
import insightsCover from "../../../media/images/insightsCover.jpg";
import insightsCoverMobile from "../../../media/images/insightsCoverMobile.jpg";
import illustrationIntranet from "../../../media/images/illustrationIntranet.jpg";
import beauty from "../../../media/images/beauty.jpg";
import praxis from "../../../media/images/praxis.jpg";
import it from "../../../media/images/it.jpg";
import handwork from "../../../media/images/handwork.jpg";
import business from "../../../media/images/business.jpg";
import restaurant from "../../../media/images/restaurant.jpg";
import tourism from "../../../media/images/tourism.jpg";
import multifunction from "../../../media/images/multifunction.jpg";
import soon from "../../../media/images/soon.jpg";
// import illustrationTeams from '../../../media/images/illustrationTeams.jpg';
import news from "../../../media/images/news.png";
import kms from "../../../media/images/kms.png";
import dms from "../../../media/images/dms.png";
import departments from "../../../media/images/departments.png";
import branding from "../../../media/images/branding.png";
import events from "../../../media/images/events.png";
import community from "../../../media/images/community.png";
import search from "../../../media/images/search.png";
import intrajet from "../../../media/images/intrajet.jpg";
// import governance from '../../../media/images/governance.png';
// import templates from '../../../media/images/templates.png';
// import lifecycle from '../../../media/images/lifecycle.png';
// import provisioning from '../../../media/images/provisioning.png';
// import userInterface from '../../../media/images/interface.png';
// import classes from '../../../media/images/classes.png';
// import versioning from '../../../media/images/versioning.png';
// import naming from '../../../media/images/naming.png';

export class Insights extends Component {
  constructor(props) {
    super(props);
    this.websites = React.createRef();
    this.state = {
      width: window.innerWidth,
    };
  }

  componentDidMount = () => {
    let tabs = document
      .getElementsByClassName("nav-wrapper")[1]
      .querySelectorAll("ul")[0]
      .querySelectorAll("a");
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].removeAttribute("class");

      if (tabs[i].id === "insights") {
        tabs[i].setAttribute("class", "orange-text text-darken-4");
      }
    }

    let mobileTabs = document
      .getElementsByClassName("sidenav")[0]
      .querySelectorAll("a");
    for (let i = 0; i < mobileTabs.length; i++) {
      if (mobileTabs[i].id === "insightsMobile") {
        mobileTabs[i].removeAttribute("class");
        mobileTabs[i].setAttribute(
          "class",
          "orange-text text-darken-4 grey darken-3"
        );
      }
    }

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));

    if (document.referrer.indexOf("fokusbereiche/webseiten") !== -1) {
      this.websites.current.scrollIntoView();
    }
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;
    return (
      <React.Fragment>
        <MetaDecorator
          title="JetMinds | Insights"
          descrption="SharePoint Intranet, digitale Zusammenarbeit Beratung, ready-to-start Intranet mit den wichtigsten Funktionen und Diensten eines Intranets und vieles mehr"
          url="https://www.jetminds.de/insights/"
        />
        <div className="pageImageTitle">
          {isMobile ? (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={insightsCoverMobile}
              alt="JetMinds Insights"
              loading="lazy"
            />
          ) : (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={insightsCover}
              alt="JetMinds Insights"
              loading="lazy"
            />
          )}
          {isMobile || isTablet ? (
            <div className="imgTxtMobile">
              <h1
                className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}
              >
                Insights
              </h1>
            </div>
          ) : (
            <div className="imgTxt">
              <h1 className="white-text">Insights</h1>
            </div>
          )}
        </div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`}>
                  Flexibler, leistungsstarker und{" "}
                  <span className="orange-text text-darken-4">
                    ergebnisreicher
                  </span>{" "}
                  durch{" "}
                  <span className="orange-text text-darken-4">
                    schnellen Einstieg
                  </span>{" "}
                  in die digitalisierte Zusammenarbeit
                </h1>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12 center" : "m4"}`}>
                <h5 className="center">SharePoint Online Intranet</h5>
                <img
                  className="responsive-img"
                  src={illustrationIntranet}
                  alt="JetMinds Insights Intranet"
                  loading="lazy"
                />
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m8"}`}>
                <p className="light">
                  Das Intranet ist der wichtigste unternehmensweite Startpunkt
                  der internen Kommunikation und Kollaboration zwischen den
                  Abteilungen und Mitarbeitern. Es liefert die Informationen und
                  Nachrichten des Unternehmens und stellt sicher, dass die
                  Informationen aktuell sind, um Transparenz im Unternehmen zu
                  erreichen. Über das Intranet können Mitarbeiter auch auf
                  interne Ressourcen innerhalb des Unternehmens zugreifen.
                </p>
                <p className="light">
                  Unsere Entscheidung, ein perfektes Intranet auf Basis von
                  Microsoft SharePoint Online zu erstellen, beruht auf
                  mehrjährigen Erfahrungen, da uns die SharePoint-Plattform mit
                  ihren vielen wertvollen Funktionen und breitgefächerten
                  Diensten sowie Sicherheit überzeugt hat. Wir bieten eine
                  Vielzahl von Optionen und Tools zum Erstellen von
                  Intranetsites für Ihr Unternehmen auf der Basis von Microsoft
                  SharePoint Online.
                </p>
                <p className="light">
                  Mit unserem <b>IntraJet</b>, ein von uns entwickeltes und
                  bereits konfiguriertes, ready-to-start Intranet, das die
                  wichtigsten Funktionen und Dienste eines Intranets enthält,
                  können Sie den Einstieg in die digitale Zusammenarbeit sofort
                  starten. IntraJet ist das Ergebnis unseres durchdachten
                  Konzepts, kleinen und mittelständigen Unternehmen zu helfen,
                  sich schnell zu digitalisieren und ein Intranet mit den
                  meisten Funktionen und Tools zu erhalten, die sie für ihren
                  Einstieg benötigen. Die folgenden acht Hauptfunktionen und
                  -werkzeuge sind in unserem IntraJet enthalten:
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col s6 m3">
                <div className="center">
                  <img
                    className="responsive-img"
                    width={100}
                    src={news}
                    alt="JetMinds Insights Intranet News"
                    loading="lazy"
                  />
                </div>
                <h5 className="center breakLine">News</h5>
              </div>
              <div className="col s6 m3">
                <div className="center">
                  <img
                    className="responsive-img"
                    width={100}
                    src={events}
                    alt="JetMinds Insights Intranet Events"
                    loading="lazy"
                  />
                </div>
                <h5 className="center">Events</h5>
              </div>
              <div className="col s6 m3">
                <div className="center">
                  <img
                    className="responsive-img"
                    width={100}
                    src={dms}
                    alt="JetMinds Insights Intranet DMS"
                    loading="lazy"
                  />
                </div>
                <h5 className="center breakLine">DMS</h5>
              </div>
              <div className="col s6 m3">
                <div className="center">
                  <img
                    className="responsive-img"
                    width={100}
                    src={search}
                    alt="JetMinds Insights Intranet Suche"
                    loading="lazy"
                  />
                </div>
                <h5 className="center">Search</h5>
              </div>
            </div>
            <div className="row">
              <div className="col s12">
                <div className="center">
                  <img
                    className="responsive-img"
                    width={175}
                    src={intrajet}
                    alt="JetMinds Insights Intranet"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col s6 m3">
                <div className="center">
                  <img
                    className="responsive-img"
                    width={100}
                    src={departments}
                    alt="JetMinds Insights Intranet Departments"
                    loading="lazy"
                  />
                </div>
                <h5 className="center breakLine">Departments</h5>
              </div>
              <div className="col s6 m3">
                <div className="center ">
                  <img
                    className="responsive-img"
                    width={100}
                    src={kms}
                    alt="JetMinds Insights Intranet Knowlegebase"
                    loading="lazy"
                  />
                </div>
                <h5 className="center breakLine">Knowlegebase</h5>
              </div>
              <div className="col s6 m3">
                <div className="center">
                  <img
                    className="responsive-img"
                    width={100}
                    src={community}
                    alt="JetMinds Insights Intranet Community"
                    loading="lazy"
                  />
                </div>
                <h5 className="center breakLine">Community</h5>
              </div>
              <div className="col s6 m3">
                <div className="center">
                  <img
                    className="responsive-img"
                    width={100}
                    src={branding}
                    alt="JetMinds Insights Intranet Branding"
                    loading="lazy"
                  />
                </div>
                <h5 className="center breakLine">Branding</h5>
              </div>
            </div>
            <div className="row center">
              <div className="col s12 m6 push-m3">
                <a
                  href="/kontakt"
                  className="btn-large orange darken-4"
                  style={{ width: "100%" }}
                >
                  Jetzt Demo anfragen
                </a>
              </div>
            </div>
          </div>

          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <h1
                  className={`${isMobile ? "pageTitleM" : "pageTitle"}`}
                  ref={this.websites}
                >
                  Moderne, responsive und{" "}
                  <span className="orange-text text-darken-4">performante</span>{" "}
                  Websites für die digitale Präsenz Ihrer{" "}
                  <span className="orange-text text-darken-4">
                    Unternehmenskommunikation
                  </span>
                </h1>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={business}
                      alt="Business"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Business<i className="material-icons right">more_vert</i>
                    </span>
                    <a
                      className="orange-text text-darken-4"
                      href="https://business.jetminds.de"
                      target="_blanck"
                      rel="nofollow"
                    >
                      Website ansehen
                    </a>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Business<i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Hier sehen Sie ein Beispiel für ein mittelständiges
                      Unternehmen. Es hilft Ihnen einen ersten Eindruck zu
                      gewinnen, wie Ihre Unternehmenswebsite aussehen könnte.
                      Klicken Sie auf{" "}
                      <a
                        className="orange-text text-darken-4"
                        href="https://business.jetminds.de"
                        target="_blanck"
                        rel="nofollow"
                      >
                        Website ansehen
                      </a>{" "}
                      um das Beispiel aufzurufen.
                    </p>
                  </div>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={it}
                      alt="JetMinds Selbstständige"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Selbstständige
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <a
                      className="orange-text text-darken-4"
                      href="https://max.jetminds.de"
                      target="_blanck"
                      rel="nofollow"
                    >
                      Website ansehen
                    </a>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Selbstständige
                      <i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Als Freiberufler/in ist der erste Eindruck Ihrer
                      Leistungen von entscheidender Bedeutung. Hier können Sie
                      sich ein Beispiel eines modernen Designs ansehen.{" "}
                      <a
                        className="orange-text text-darken-4"
                        href="https://max.jetminds.de"
                        target="_blanck"
                        rel="nofollow"
                      >
                        Hier
                      </a>{" "}
                      geht es zur Website, viele Spaß!
                    </p>
                  </div>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={praxis}
                      alt="Arztpraxis Webseite"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Arztpraxis
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <a
                      className="orange-text text-darken-4"
                      href="https://praxis.jetminds.de"
                      target="_blanck"
                      rel="nofollow"
                    >
                      Website ansehen
                    </a>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Arztpraxis<i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Hier finden Sie ein Beispiel für eine Arztpraxis. Es hilft
                      Ihnen einen ersten Eindruck zu gewinnen, wie Ihre Website
                      aussehen könnte. Klicken Sie auf{" "}
                      <a
                        className="orange-text text-darken-4"
                        href="https://praxis.jetminds.de"
                        target="_blanck"
                        rel="nofollow"
                      >
                        Website ansehen
                      </a>{" "}
                      um das Beispiel aufzurufen.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={handwork}
                      alt="JetMinds Handwerker"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Handwerker
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <a
                      className="orange-text text-darken-4"
                      href="https://handwork.jetminds.de"
                      target="_blanck"
                      rel="nofollow"
                    >
                      Website ansehen
                    </a>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Handwerker<i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Auch für Handwerker ist eine Webseite von sehr wichtiger
                      Bedeutung. Ihre Website ist Ihr Online-Repräsentant an 365
                      Tagen rund um die Uhr, deswegen sollte Ihre Webseite
                      aussagekräftig und überzeugend sein.{" "}
                      <a
                        className="orange-text text-darken-4"
                        href="https://handwork.jetminds.de"
                        target="_blanck"
                        rel="nofollow"
                      >
                        Hier
                      </a>{" "}
                      finden Sie ein Beispiel einer modernen Website.
                    </p>
                  </div>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={restaurant}
                      alt="JetMinds Restaurant Website"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Restaurant
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <a
                      className="orange-text text-darken-4"
                      href="https://restaurant.jetminds.de"
                      target="_blanck"
                      rel="nofollow"
                    >
                      Website ansehen
                    </a>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Restaurant<i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Als Restaurant ist der erste Eindruck Ihrer Gerichte und
                      Ihres Ambientes von entscheidender Bedeutung.{" "}
                      <a
                        className="orange-text text-darken-4"
                        href="https://restaurant.jetminds.de"
                        target="_blanck"
                        rel="nofollow"
                      >
                        Hier
                      </a>{" "}
                      können Sie sich ein Beispiel eines modernen Designs
                      ansehen.
                    </p>
                  </div>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={beauty}
                      alt="Schönheitssalons"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Schönheitssalons
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <a
                      className="orange-text text-darken-4"
                      href="https://beauty.jetminds.de"
                      target="_blanck"
                      rel="nofollow"
                    >
                      Website ansehen
                    </a>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Schönheitssalons
                      <i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Hier sehen Sie ein Beispiel für einen Schönheitssalon. Es
                      hilft Ihnen einen ersten Eindruck zu gewinnen, wie Ihre
                      Website aussehen könnte. Klicken Sie auf{" "}
                      <a
                        className="orange-text text-darken-4"
                        href="https://beauty.jetminds.de"
                        target="_blanck"
                        rel="nofollow"
                      >
                        Website ansehen
                      </a>{" "}
                      um das Beispiel aufzurufen.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={tourism}
                      alt="JetMinds Reisebüro & Tourismus Webdesign"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Reisebüro & Tourismus
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <a
                      className="orange-text text-darken-4"
                      href="https://tourism.jetminds.de"
                      target="_blanck"
                      rel="nofollow"
                    >
                      Website ansehen
                    </a>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Reisebüro & Tourismus
                      <i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Als Reisebüro und Tourismusspezialist ist der erste
                      Eindruck Ihrer Leistungen von entscheidender Bedeutung.{" "}
                      <a
                        className="orange-text text-darken-4"
                        href="https://tourism.jetminds.de"
                        target="_blanck"
                        rel="nofollow"
                      >
                        Hier
                      </a>{" "}
                      können Sie sich ein Beispiel eines modernen Designs
                      ansehen.
                    </p>
                  </div>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={multifunction}
                      alt="JetMinds Multifunktion Website"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Multifunktion
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <a
                      className="orange-text text-darken-4"
                      href="https://multifunktion.jetminds.de"
                      target="_blanck"
                      rel="nofollow"
                    >
                      Website ansehen
                    </a>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Vielseitige Anwendung
                      <i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Hier handelt es sich um ein vielseitig verwendbares
                      Webdesign, das branchenunabhängig ist. Es ist ein Beispiel
                      und das Design, die Bilder und die Farbgestalltung werden
                      für Sie maßgeschneidert.{" "}
                      <a
                        className="orange-text text-darken-4"
                        href="https://multifunktion.jetminds.de"
                        target="_blanck"
                        rel="nofollow"
                      >
                        Hier
                      </a>{" "}
                      geht es zu dem Beispiel.
                    </p>
                  </div>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={soon}
                      alt="JetMinds Künstler"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Künstler<i className="material-icons right">more_vert</i>
                    </span>
                    <p className="orange-text text-darken-4">„Kommt bald“</p>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Künstler<i className="material-icons right">close</i>
                    </span>
                    <p className="light">Noch nicht fertig :)</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={soon}
                      alt="JetMinds Sport und Fitness Website"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Sport und Fitness
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <p className="orange-text text-darken-4">„Kommt bald“</p>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Sport und Fitness
                      <i className="material-icons right">close</i>
                    </span>
                    <p className="light">Wir arbeiten noch daran!</p>
                  </div>
                </div>
              </div>

              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={soon}
                      alt="JetMinds Multifunktion Website"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Multifunktion + Onlineshop
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <p className="orange-text text-darken-4">„Kommt bald“</p>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Vielseitige Anwendung
                      <i className="material-icons right">close</i>
                    </span>
                    <p className="light">Wir arbeiten noch daran!</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row center">
              <div className="col s12 m6 push-m3">
                <a
                  href="/kontakt"
                  className="btn-large orange darken-4"
                  style={{ width: "100%" }}
                >
                  Mehr erfahren
                </a>
              </div>
            </div>
          </div>
          {/* <div className="section">
                    <div className="row">
                            <div className={`col s12 ${isTablet ? "m12 center" : "m4"}`}>
                                <h5 className="center">Microsoft Teams</h5>
                                <img className="responsive-img" src={illustrationTeams} alt="JetMinds Insights Intranet" loading="lazy"/>
                            </div>
                            <div className={`col s12 ${isTablet ? "m12" : "m8"}`}>
                                <p className="light">Da Arbeitsbereiche auf unterschiedliche Weise und an unterschiedlichen Standorten erstellt werden können, kann dies schnell außer Kontrolle geraten. Die Provisionierung bezieht sich hier auf die automatische Erstellung und Konfiguration von Arbeitsbereichen anstelle einer Person, die die gesamte Arbeit manuell ausführt. Unter Arbeitsbereichen verstehen wir Orte für die digitale Zusammenarbeit, z. B. SharePoint Online-Websites, O365-Gruppen sowie <a className="orange-text text-darken-4" href="/fokusbereiche/microsoft-teams">Teams</a> und TeamSites.</p>
                                <p className="light">Da Arbeitsbereiche auf unterschiedliche Weise und an unterschiedlichen Standorten erstellt werden können, kann dies schnell außer Kontrolle geraten. Die Provisionierung bezieht sich hier auf die automatische Erstellung und Konfiguration von Arbeitsbereichen anstelle einer Person, die die gesamte Arbeit manuell ausführt. Unter Arbeitsbereichen verstehen wir Orte für die digitale Zusammenarbeit, z. B. SharePoint Online-Websites, O365-Gruppen sowie <a className="orange-text text-darken-4" href="/fokusbereiche/microsoft-teams">Teams</a> und TeamSites.</p>
                                <p className="light">Da Arbeitsbereiche auf unterschiedliche Weise und an unterschiedlichen Standorten erstellt werden können, kann dies schnell außer Kontrolle geraten. Die Provisionierung bezieht sich hier auf die automatische Erstellung und Konfiguration von Arbeitsbereichen anstelle einer Person, die die gesamte Arbeit manuell ausführt. Unter Arbeitsbereichen verstehen wir Orte für die digitale Zusammenarbeit, z. B. SharePoint Online-Websites, O365-Gruppen sowie <a className="orange-text text-darken-4" href="/fokusbereiche/microsoft-teams">Teams</a> und TeamSites.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col s6 m3">
                                <div className="center">
                                    <img className="responsive-img" width={100} src={governance} alt="JetMinds Insights KollabHub Governance" loading="lazy"/>
                                </div>
                                <h5 className="center breakLine">Governance</h5>
                            </div>
                            <div className="col s6 m3">
                                <div className="center">
                                    <img className="responsive-img" width={100} src={provisioning} alt="JetMinds Insights KollabHub Provisioning" loading="lazy"/>
                                </div>
                                <h5 className="center breakLine">Provisioning</h5>
                            </div>
                            <div className="col s6 m3">
                                <div className="center">
                                    <img className="responsive-img" width={100} src={userInterface} alt="JetMinds Insights KollabHub Benutzerinterface" loading="lazy"/>
                                </div>
                                <h5 className="center breakLine">User interface</h5>
                            </div>
                            <div className="col s6 m3">
                                <div className="center">
                                    <img className="responsive-img" width={100} src={naming} alt="JetMinds Insights KollabHub Namenskonvention" loading="lazy" />
                                </div>
                                <h5 className="center breakLine">Naming convention</h5>
                            </div>
                            <div className="col s6 m3">
                                <div className="center">
                                    <img className="responsive-img" width={100} src={versioning} alt="JetMinds Insights KollabHub Versionierung" loading="lazy"/>
                                </div>
                                <h5 className="center breakLine">Versioning</h5>
                            </div>
                            <div className="col s6 m3">
                                <div className="center">
                                    <img className="responsive-img" width={100} src={templates} alt="JetMinds Insights KollabHub Templates" loading="lazy"/>
                                </div>
                                <h5 className="center breakLine">Templates</h5>
                            </div>
                            <div className="col s6 m3">
                                <div className="center">
                                    <img className="responsive-img" width={100} src={classes} alt="JetMinds Insights KollabHub Klassifizierung" loading="lazy"/>
                                </div>
                                <h5 className="center breakLine">Classification</h5>
                            </div>
                            <div className="col s6 m3">
                                <div className="center">
                                    <img className="responsive-img" width={100} src={lifecycle} alt="JetMinds Insights KollabHub Lebenszyklus" loading="lazy"/>
                                </div>
                                <h5 className="center breakLine">Lifecycle</h5>
                            </div>
                        </div>
                        <div className="row center">
                            <div className="col s12 m6 push-m3">
                                <a href="/kontakt" className="btn-large orange darken-4" style={{ width: '100%' }}>Jetzt Demo anfragen</a>
                            </div>
                        </div>
                    </div> */}
        </div>
      </React.Fragment>
    );
  }
}

export default Insights;



// WEBPACK FOOTER //
// ./src/components/layout/pages/Insights.js